import {CircularProgress} from "@mui/material";

export const Loading = () => {
    return (
        <div style={{display: "flex", justifyContent: "center", height: "100%", alignItems: "center"}}>
            <CircularProgress/>
        </div>
    )
}